/** Atom */
export interface AtomObj {
  key: string;
  default: any;
}

export interface APIEndpoint {
  url: string;
  isMock: boolean;
}

export enum utmFunctionsType {
  NOTIFICATION = "notification",
  REFERRER = "referrer",
}
